<template>
  <div class="caap">
    <!-- Breadcrumbs -->
    <nav class="flex px-2 lg:px-12 justify-between items-center" aria-label="Breadcrumb">
      <div class="flex items-center">
        <!-- <button @click="goToMockExamHistory()" class="ml-2 text-sm font-medium text-warm-gray-500 hover:text-warm-gray-400" aria-current="page">
          <ChevronDoubleLeftIcon class="flex-shrink-0 h-6 w-6" aria-hidden="true" />
        </button> -->
        <button @click="goToCaapPlusHome()" class="ml-2 text-sm font-medium text-warm-gray-500 hover:text-warm-gray-400" aria-current="page">
          <ChevronDoubleLeftIcon class="flex-shrink-0 h-6 w-6" aria-hidden="true" />
        </button>
      </div>
      <div class="text-sm font-medium text-warm-gray-500">
        <span class="hidden md:block">View Mock Exam</span>
        <span class="block md:hidden">View Mock Exam</span>
      </div>
      <!-- Added an empty div, so the title is centered -->
      <div class="inline-block text-left w-5 h-5" />
    </nav>

    <!-- Main Content -->
    <main class="max-w-full mx-auto py-8 px-4 sm:py-10 sm:px-6 lg:max-w-7xl lg:px-8">
    
      <div v-if="isLoading" class="mt-6 sm:mt-0 flex flex-col sm:py-6 sm:px-6 max-w-full mx-auto lg:max-w-7xl space-y-6">
          <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div class="shadow overflow-hidden border-b border-gray-200 dark:border-gray-800 sm:rounded-lg bg-true-gray-200 dark:bg-true-gray-800 animate-pulse h-96">
              </div>
            </div>
          </div>
      </div>
      <div v-else-if="isUnavailable" class="mt-6 sm:mt-0 flex flex-col sm:py-6 sm:px-6 max-w-full mx-auto lg:max-w-7xl space-y-6">
          <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div class="shadow overflow-hidden border-b border-gray-200 dark:border-gray-800 sm:rounded-lg bg-true-gray-200 dark:bg-true-gray-800 h-auto px-8 py-8">

                <h1 class="text-xl text-true-gray-400 font-semibold">😅 Mock Exam Data Unavailable</h1>
                <p class="text-true-gray-500 mt-4 pr-12">Our system cannot retreive the data for this Mock Exam. Please make sure that you took this exam after March 30, 2023 where the 'Mock Exam Explorer' feature was first released.</p>
                <p class="text-true-gray-500 mt-4 pr-12">If you have any questions or concerns, please contact us via Email (support@skilltech.ph) or Facebook Messenger, whichever is more convenient.</p>
              </div>
            </div>
          </div>
      </div>
      <div v-else class="mt-1 sm:mt-0 flex flex-col sm:py-2 sm:px-6 max-w-full mx-auto lg:max-w-7xl">
        <header v-if="!isSummaryHidden" class="bg-true-gray-800 rounded-lg">
          
          <!-- Heading -->
          <div class="flex flex-col items-start justify-between gap-x-8 gap-y-4 bg-true-gray-700/10 px-4 py-4 sm:flex-row sm:items-center sm:px-6 lg:px-8">
            <div>
              <div class="flex items-center gap-x-3">
                <!-- <div class="flex-none rounded-full bg-green-400/10 p-1 text-green-400">
                  <div class="h-2 w-2 rounded-full bg-current" />
                </div> -->
                <h1 class="flex gap-x-3 text-base leading-7">
                  <span class="font-semibold text-white">Subject: {{ getSelectedSubjectName(this.exam.subject) }}</span>
                </h1>
              </div>
              <div class="text-xs leading-6 text-true-gray-400">
                <span>Started {{ moment(this.exam.time.start).startOf('minutes').fromNow() }}. </span>
                <span>Passing score is {{this.subjects.find(e => e.id === this.exam.subject).exam.limits.passer}}% and the time limit is {{this.subjects.find(e => e.id === this.exam.subject).exam.limits.time/60}} minutes.</span>
              </div>
            </div>
            <div v-if="this.exam.result.toUpperCase() == 'FAILED'" class="order-first flex-none rounded-full bg-red-900 bg-opacity-50 px-4 py-1 text-lg font-medium text-red-500 border border-red-600 sm:order-none">Failed</div>
            <div v-else class="order-first flex-none rounded-full bg-green-900 bg-opacity-50 px-4 py-1 text-lg font-medium text-green-500 border border-green-600 sm:order-none">Passed</div>
          </div>

          <!-- Stats -->
          <div class="grid grid-cols-1 bg-gray-700/10 grid-cols-1 lg:grid-cols-4">
            <div class="border-t border-true-gray-600 py-6 px-4 sm:px-6 lg:px-8">
              <p class="text-sm font-medium leading-6 text-true-gray-400">Total Score</p>
              <p class="mt-2 flex items-baseline gap-x-2">
                <span :class="[(this.exam.result.toUpperCase() == 'FAILED') ? 'text-red-300' : 'text-green-300', 'text-4xl font-semibold tracking-tight']">{{ this.exam.score }}%</span>
              </p>
            </div>
            <div class="border-t border-true-gray-700 py-6 px-4 sm:px-6 lg:px-8 border-l lg:border-l">
              <p class="text-sm font-medium leading-6 text-true-gray-400">Total Time Spent</p>
              <p class="mt-2 flex items-baseline gap-x-2">
                <span class="text-4xl font-semibold tracking-tight text-white">{{ this.formatTime(this.exam.time.running) }}</span>
                <!-- <span  class="text-sm text-gray-400">mins</span> -->
              </p>
            </div>
            <div class="border-t border-true-gray-700 py-6 px-4 sm:px-6 lg:px-8 border-l lg:border-l">
              <p class="text-sm font-medium leading-6 text-true-gray-400">Skillpoints Earned</p>
              <p class="mt-2 flex items-baseline gap-x-2">
                <span class="text-4xl font-semibold tracking-tight text-white">{{ this.exam.skillpoints }}</span>
                <!-- <span  class="text-sm text-gray-400">mins</span> -->
              </p>
            </div>
            <div class="border-t border-true-gray-700 py-6 px-4 sm:px-6 lg:px-8 border-l lg:border-l">
              <p class="text-sm font-medium leading-6 text-true-gray-400">Milestones Acheived</p>
              <p class="mt-2 flex items-baseline gap-x-2">
                <div class="flex w-full justify-between space-x-2">
                  <div class="w-28 flex flex-col items-center">
                    <div :class="[(this.exam.milestones.includes('passer')) ? 'bg-blue-200' : 'bg-true-gray-700', 'mx-auto flex-grow-0 rounded-full w-12 h-12 p-3']">
                      <PaperClipIcon :class="[(this.exam.milestones.includes('passer')) ? 'text-blue-500' : 'text-true-gray-600', 'w-6 h-6']" />
                    </div>
                  </div>
                  <div class="w-28 flex flex-col items-center">
                    <div :class="[(this.exam.milestones.includes('speedrunner')) ? 'bg-purple-200' : 'bg-true-gray-700', 'mx-auto flex-grow-0 rounded-full w-12 h-12 p-3']">
                      <LightningBoltIcon :class="[(this.exam.milestones.includes('speedrunner')) ? 'text-purple-500' : 'text-true-gray-600', 'w-6 h-6']" />
                    </div>
                  </div>
                  <div class="w-28 flex flex-col items-center">
                    <div :class="[(this.exam.milestones.includes('master')) ? 'bg-yellow-200' : 'bg-true-gray-700', 'mx-auto flex-grow-0 rounded-full w-12 h-12 p-3']">
                      <FireIcon :class="[(this.exam.milestones.includes('master')) ? 'text-yellow-500' : 'text-true-gray-600', 'w-6 h-6']" />
                    </div>
                  </div>
                </div>
              </p>
            </div>
            
            
            
          </div>
        </header>
        
        
        <div class="w-full flex flex-col sm:flex-row items-center justify-center mt-8 mb-6">

          <div v-if="viewType == 'QUESTIONNAIRE'" class="flex items-center mr-2 relative w-full">
            <!-- <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-white ml-2.5 absolute" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clip-rule="evenodd" />
            </svg> -->
            <select v-model="itemFilter" @change="handleItemFilterChange()"
              class=" w-full bg-indigo-600 text-center text-white border-0 mb-0 rounded-md px-3 py-2 pr-7 text-sm font-semibold shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 hover:bg-indigo-500 transition appearance-none cursor-pointer pl-8"
            >
              <option value="ALL">Show All Items</option>
              <option value="CORRECT">Show Correct Items Only</option>
              <option value="WRONG">Show Wrong Items Only</option>
            </select>
          </div>

          <button @click="isSummaryHidden = (isSummaryHidden) ? false : true" type="button" class="w-full my-2 mx-2 justify-center inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
            <!-- <IdentificationIcon class="w-4 h-4"/> -->
            <span class="text-xs sm:text-sm">{{ (isSummaryHidden) ? 'Show Exam Summary' : 'Hide Exam Summary' }} </span>
          </button>
          <button @click="viewType = (viewType == 'TIMELINE') ? 'QUESTIONNAIRE' : 'TIMELINE'" type="button" class="w-full my-2 mx-2 justify-center inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
            <!-- <SwitchHorizontalIcon class="w-4 h-4"/> -->
            <span class="text-xs sm:text-sm">{{ (viewType == 'TIMELINE') ? 'Switch to Questionnaire View' : 'Switch to Timeline View' }} </span>
          </button>
        </div>

        <!-- Timeline View -->
        <main v-if="viewType == 'TIMELINE'" class="text-white mb-28">
          <div class="mt-2 mb-6">
            <p class="text-sm leading-6 dark:text-true-gray-400 text-true-gray-600">
              <span class="font-bold">NOTE: </span>Below is a timeline of your mock exam wherein you'll see how long you answered each question. An 'OVER' label means you took a little bit more time to answer the question while 'HIGH' means you took too much time needed. Correctly answered items are indicated as green and incorrect answers are indicated as red. You can click each question to see more details.
            </p>
          </div>
          <ul>
            <li v-for="(data, i) in graphData" :key="i" class="flex items-center space-x-2">
              <div @click="showData(i)" :class="[(data.isCorrect) ? 'bg-green-600 dark:bg-green-500' : 'bg-red-600 dark:bg-red-500','text-center rounded-md my-1 py-1 px-2 text-sm cursor-pointer hover:opacity-70 whitespace-nowrap']">
                Question {{ i+1 }}
              </div>
              <div class="z-0 h-5 bg-true-gray-200 dark:bg-true-gray-800 opacity-90" :style="`width: 100%`">
                <div @click="showData(i)" :class="[(data.isCorrect) ? 'bg-green-600 dark:bg-green-500' : 'bg-red-600 dark:bg-red-500', 'cursor-pointer hover:opacity-70 z-30 h-5']" :style="`width: ${data.timePercentage}%`">
                  <div v-if="i > 0" class="h-5 flex items-center bg-true-gray-200 dark:bg-true-gray-800 pointer-events-none" :style="`width: ${(graphData[i-1].timePercentage/data.timePercentage)*100}%`">
                    <div v-if="data.isSkipped" class="text-xs text-yellow-400 pl-2 font-bold pointer-events-none">SKIPPED</div>
                  </div>
                </div>
              </div>
              <div class="w-8 text-center rounded-md text-xs hover:opacity-70">

                <div v-if="(graphData[i].userTookTime/1000) >= (timePerQuestion*2)" class="dark:text-red-400 text-red-700">HIGH</div>
                <div v-else-if="(graphData[i].userTookTime/1000) > timePerQuestion" class="dark:text-purple-400 text-purple-700">OVER</div>
                <div v-else-if="(graphData[i].userTookTime/1000) < (timePerQuestion/2)" class="dark:text-yellow-400 text-yellow-700">FAST</div>
                <div v-else-if="(graphData[i].userTookTime/1000) <= timePerQuestion" class="dark:text-gray-400 text-gray-700">NORMAL</div>
                
              </div>
              
            </li>
          </ul>
        </main> 
        
        <!-- Questionnaire View -->
        <main v-if="viewType == 'QUESTIONNAIRE'" class="max-w-full mx-auto px-1 sm:py-8 w-full space-y-4 mb-28">
      
          <!-- Stats -->
          <div id="stats" class="dark:border-true-gray-700 min-h-60 rounded-md mb-4 flex justify-between">
            <div class="flex dark:text-warm-gray-500 text-warm-gray-800 text-md items-center">
              <FlagIcon class="w-5 h-5 mr-1" />
              <p class="hidden sm:block ml-2 font-medium dark:text-warm-gray-500 text-warm-gray-800">
                <span v-if="itemFilter == 'ALL'">
                  Question No. {{ questionnaireExplorerIndex + 1 }} out of {{ filteredQuestionnaire.length }}
                </span>
                <span v-else>
                  Question No. {{ questionnaireExplorerIndex + 1 }} — You got {{ filteredQuestionnaire.length }} items {{ (itemFilter == 'CORRECT') ? 'correct' : 'wrong' }} out of {{ this.exam.questionnaire.length }}
                </span>
              </p>
              <p class="block sm:hidden ml-2 font-medium dark:text-warm-gray-500 text-warm-gray-800">
                Q{{ questionnaireExplorerIndex + 1 }} ({{ filteredQuestionnaire.length }}/{{ this.exam.questionnaire.length }})
              </p>
              
            </div>
            <div class="flex text-warm-gray-800 text-md items-center space-x-2">

              <div v-if="this.exam.questionnaire[questionnaireExplorerIndex].isSkipped" class="text-yellow-800 font-bold bg-yellow-300 text-xs px-2 py-1 rounded">
                SKIPPED
              </div>

              <div class="text-warm-gray-500 flex items-center space-x-1">

                <ClockIcon class="w-5 h-5 mr-2" />
                <span>
                  {{ computeTimeDiff()}} seconds
                </span>
                <div v-if="(graphData[questionnaireExplorerIndex].userTookTime/1000) >= (timePerQuestion*2)" class="text-xs bg-red-800 px-2 py-1 rounded-full text-red-200">HIGH</div>
                <div v-else-if="(graphData[questionnaireExplorerIndex].userTookTime/1000) > timePerQuestion" class="text-xs bg-purple-800 px-2 py-1 rounded-full text-purple-200">OVER</div>
                <div v-else-if="(graphData[questionnaireExplorerIndex].userTookTime/1000) < (timePerQuestion/2)" class="text-xs bg-yellow-800 px-2 py-1 rounded-full text-yellow-200">FAST</div>
                <div v-else-if="(graphData[questionnaireExplorerIndex].userTookTime/1000) <= timePerQuestion" class="text-xs bg-gray-800 px-2 py-1 rounded-full text-gray-200">NORMAL</div>
              
              </div>

            </div>
          </div>

          <!-- Question -->
          <div class="select-none text-left text-warm-gray-900 dark:text-warm-gray-300 rounded-md -space-y-px p-6 border-2 border-dashed border-warm-gray-300 dark:border-true-gray-700 whitespace-pre-line">
            <!-- <p class="mb-4 text-yellow-400">📌 From Subtopic: <strong>{{ getSelectedSubtopicName(this.exam.questionnaire[questionnaireExplorerIndex].subtopic) }}</strong></p> -->
            <!-- {{ this.exam.questionnaire[questionnaireExplorerIndex].question }} -->
            <div v-html="this.exam.questionnaire[questionnaireExplorerIndex].questionHtml"></div>
            <img v-if="this.exam.questionnaire[questionnaireExplorerIndex].hasImage" :src="this.exam.questionnaire[questionnaireExplorerIndex].imageUrl" class="lg:max-w-24 rounded-xl mx-auto my-2 mt-4">
          </div>

          <!-- Choices -->
          <div id="choices" class="select-none mt-4">
            <ul class="text-warm-gray-800 dark:text-warm-gray-400 text-left rounded-md shadow-sm -space-y-px">
              <li v-for="(choice, idX) in this.exam.questionnaire[questionnaireExplorerIndex].choices" :key="idX">
                <button
                  :class="[ showSelected(choice.id), setBorder(idX), 'flex justify-between border border-warm-gray-300 dark:border-true-gray-700 relative shadow-sm px-5 py-4 cursor-pointer text-left focus:outline-none w-full disabled:cursor-auto']"
                >
                  <!-- <span>{{ choice.choice }} ==> {{ choice.id }}</span> -->
                  <!-- <span>{{ choice.choice }}</span> -->
                  <div v-html="choice.choiceHtml"></div>
                  
                    <span v-if="choice.id == this.exam.questionnaire[questionnaireExplorerIndex].answer">
                      <CheckCircleIcon class="text-green-500 h-5 w-5" />
                    </span>
                    <span v-else>
                      <XCircleIcon class="text-red-500 h-5 w-5" />
                    </span>
                  
                </button>
              </li>
            </ul>
          </div>

          <!-- Action Buttons -->
          <nav class="mt-6 flex justify-between space-x-4">
            

            <button
              :disabled="!hasPreviousFilteredQuestion"
              @click="handlePreviousClick()"
              class="disabled:opacity-50 w-full sm:w-auto space-x-4 flex flex-inline justify-center items-center disabled:cursor-auto p-4 sm:px-5 shadow-sm border border-warm-gray-300 dark:border-true-gray-700 shadow-sm font-medium rounded-md text-warm-gray-700 dark:text-warm-gray-400 bg-white dark:bg-true-gray-800 hover:bg-warm-gray-100 dark:hover:bg-true-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Previous
              <!-- <ChevronDoubleRightIcon class="h-5 w-5 dark:text-warm-gray-400 text-warm-gray-500 ml-1"/> -->
            </button>
            

            <button
              :disabled="!hasNextFilteredQuestion"
              @click="handleNextClick()"
              class="disabled:opacity-50 w-full sm:w-auto space-x-4 flex flex-inline justify-center items-center disabled:cursor-auto p-4 sm:px-5 shadow-sm border border-warm-gray-300 dark:border-true-gray-700 shadow-sm font-medium rounded-md text-warm-gray-700 dark:text-warm-gray-400 bg-white dark:bg-true-gray-800 hover:bg-warm-gray-100 dark:hover:bg-true-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Next
              <!-- <ChevronDoubleRightIcon class="h-5 w-5 dark:text-warm-gray-400 text-warm-gray-500 ml-1"/> -->
            </button>


          </nav>

        </main>


      </div>
        
    </main>
  </div>
</template>

<script>
// Import firebase dependencies
import firebase from "@/firebase/config";
import "firebase/auth";
import "firebase/firestore";
import Logo from "@/components/Logo"
const db = firebase.firestore();


// Import UI dependencies
import { FlagIcon, ChartSquareBarIcon, ClockIcon, ChevronDoubleLeftIcon, 
  IdentificationIcon, PaperClipIcon, LightningBoltIcon, FireIcon, ChevronDownIcon, SortAscendingIcon, QuestionMarkCircleIcon, PlusIcon, CursorClickIcon, CheckCircleIcon, XCircleIcon, SwitchHorizontalIcon } from "@heroicons/vue/solid";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import moment from "moment";

import { userService } from '@/utils/user';
import { reviewerService } from '@/utils/reviewer';
import { examService } from '@/utils/exam';
import { expirationGuard } from "@/utils/helper"
import axios from "axios";

const apiKey = process.env.VUE_APP_OPENAI_API_KEY;
const client = axios.create({
    headers: {
      Authorization: "Bearer " + apiKey,
    },
});

export default {
  components: {
    SwitchHorizontalIcon, PaperClipIcon, LightningBoltIcon, FireIcon, FlagIcon, ChartSquareBarIcon, ClockIcon, ChevronDoubleLeftIcon, QuestionMarkCircleIcon, PlusIcon, CursorClickIcon, ChevronDownIcon, SortAscendingIcon, CheckCircleIcon, XCircleIcon, IdentificationIcon,
    Menu, MenuButton, MenuItem, MenuItems,
    Logo
  },
  data(){
    return {
      explanation: {},
      alreadyVoted: false,
      voteType: '',
      isWaitingForExplanation: false,
      answerExplanation: '',
      answerExplanationArr: [],
      isUnavailable: false,
      isSummaryHidden: false,
      subtopics: null,
      subjects: null,
      subject: null,
      user: null,
      isLoading: true,
      exam: null,
      graphData: [],
      moment: moment,
      timePerQuestion: null,
      selected: "all-subjects",
      viewType: 'QUESTIONNAIRE',
      questionnaireExplorerIndex: 0,
      showNoExplanation: false,
      itemFilter: 'ALL',
    }
  },
  name: "Caap Mock Exam History",
  computed: {
    filteredQuestionnaire(){
      if(!this.exam || !Array.isArray(this.exam.questionnaire)) return [];
      return this.exam.questionnaire.filter(questionnaire => this.matchesCurrentFilter(questionnaire));
    },
    hasPreviousFilteredQuestion(){
      if(!this.exam || !Array.isArray(this.exam.questionnaire)) return false;
      return this.findFilteredIndex(this.questionnaireExplorerIndex, -1) !== null;
    },
    hasNextFilteredQuestion(){
      if(!this.exam || !Array.isArray(this.exam.questionnaire)) return false;
      return this.findFilteredIndex(this.questionnaireExplorerIndex, 1) !== null;
    }
  },
  // mounted() {
  //   firebase.auth().currentUser.getIdTokenResult()
  //     .then((tokenResult) => {
  //       (tokenResult.claims.caap) 
  //         ? this.caapPurchased = true 
  //         : this.$router.push({ path: "/reviewers" });
  //     });
  // },
  async created(){
    this.isLoading = true

    // Capture exam_id once at start; route can change after redirects/async, so don't read from $route later
    const examId = this.$route.params.exam_id;
    if (!examId || examId === 'undefined') {
      this.$router.replace({ path: '/reviewers' });
      this.isLoading = false;
      return;
    }

    document.getElementById('app').scrollIntoView({ behavior: 'smooth' });

    /* CLAIMS - Guard Clause */
    let claims = await userService.fetchUserClaims(firebase.auth())
    if(!claims.isOnboarded) {
      this.$router.push({ path: '/onboarding' });
      this.isLoading = false;
      return;
    }
    // Allow caap_plus users on Plus review page (they may not have main caap claim)
    if(!claims.caap_plus) {
      this.$router.push({ path: '/reviewers' });
      this.isLoading = false;
      return;
    }

    this.user = await userService.fetchUserData(firebase.firestore(), firebase.auth().currentUser.uid);
    if(!this.user.license || !this.user.license.exam_date) {
      this.$router.push({ path: '/onboarding-caap' });
      this.isLoading = false;
      return;
    }
    expirationGuard(this.user, this.$router);

    var uid = firebase.auth().currentUser.uid;

    this.subtopics = await reviewerService.fetchAllSubtopics(db, "plus")
    this.subjects = await reviewerService.fetchAllSubjects(db, "plus")

    try {
      this.exam = await examService.fetchPlusMockExam(firebase.firestore(), examId);


      // console.log('this.exam', this.exam)

      let timestamp_of_feature_release = 1688130323917;
      if(this.exam.time.start < timestamp_of_feature_release){
        console.log("EXAM WAS FROM BEFORE THE MOCK EXAM EXPLORER WAS RELEASED.")
        this.isUnavailable = true;
      }else{
        this.computeTimes();
      }
      
    }catch (err){
      console.log(err)
      this.isUnavailable = true;
    }
    this.isLoading = false
    
  },
  methods: {

    handleItemFilterChange(){
      this.questionnaireExplorerIndex = this.getFirstFilteredIndex();
    },

    handlePreviousClick(){
      const previousIndex = this.findFilteredIndex(this.questionnaireExplorerIndex, -1);
      if(previousIndex !== null){
        this.questionnaireExplorerIndex = previousIndex;
      }
    },
    handleNextClick(){
      const nextIndex = this.findFilteredIndex(this.questionnaireExplorerIndex, 1);
      if(nextIndex !== null){
        this.questionnaireExplorerIndex = nextIndex;
      }
    },

    matchesCurrentFilter(question){
      if(!question) return false;
      if(this.itemFilter === 'ALL') return true;
      if(this.itemFilter === 'CORRECT') return question.answer == question.userAnswer;
      if(this.itemFilter === 'WRONG') return question.answer != question.userAnswer;
      return true;
    },

    findFilteredIndex(startIndex, direction){
      if(!this.exam || !Array.isArray(this.exam.questionnaire)) return null;
      let index = startIndex + direction;
      while(index >= 0 && index < this.exam.questionnaire.length){
        const question = this.exam.questionnaire[index];
        if(this.matchesCurrentFilter(question)){
          return index;
        }
        index += direction;
      }
      return null;
    },

    getFirstFilteredIndex(){
      const firstIndex = this.findFilteredIndex(-1, 1);
      return firstIndex !== null ? firstIndex : 0;
    },

    // goToMockExamHistory(){
    //   if(this.$route.query.fromCourse){
    //     this.$router.push({ path: `/caap/course/${this.$route.query.fromCourse}` });
    //   }else{
    //     this.$router.push({ path: '/caap/history' })
    //   }
    // },

    goToCaapPlusHome(){
      this.$router.push({ path: '/plus/subjects' })
    },


    /**
     * Returns the HTML classes for the border of the choices container.
     * If first choice, set the top border as curved
     * If last choice, set the bottom border as curved
     * @NOTE: Utility function for UI
     * @TODO: Check if can be converted into reusable library. Also used in Practice Exam.
     * -- Issue for TODO: Using this.questionnaire (Practice) instead of this.exam.questionnaire (Mock)
     */
     setBorder(i) {
      if (i == 0) { 
        return "rounded-tl-md rounded-tr-md" 
      } else if (i == this.exam.questionnaire[this.questionnaireExplorerIndex].choices.length - 1) {
        return "rounded-bl-md rounded-br-md";
      }
    },

    /**
     * Returns the corresponding HTML classes for the selected choice or otherwise
     * @NOTE: Utility function for UI
     * @TODO: Check if can be converted into reusable library. Also used in Practice Exam.
     * -- Issue for TODO: Using this.questionnaire (Practice) instead of this.exam.questionnaire (Mock)
     */
    showSelected(id) {

      return (this.exam.questionnaire[this.questionnaireExplorerIndex].userAnswer.toString() == id.toString())
        ? "bg-true-gray-100 dark:bg-true-gray-700"
        : "bg-white dark:bg-true-gray-800 hover:bg-true-gray-100 dark:hover:bg-true-gray-700";

      // return (this.exam.answers[this.questionnaireExplorerIndex].answer.toString() == id.toString())
      //   ? "bg-true-gray-100 dark:bg-true-gray-700"
      //   : "bg-white dark:bg-true-gray-800 hover:bg-true-gray-100 dark:hover:bg-true-gray-700";
    },

    /**
     * Format's a timestamp for UI display
     * @NOTE: Utility function.
     * @TODO: Convert into reusable library
     */
     formatTime(time) {
      let momentedTime = this.moment("2015-01-01").startOf("day").seconds(time);
      return this.moment(momentedTime).format("HH:mm:ss");
    },


    showData(i){
      this.questionnaireExplorerIndex = i;
      this.viewType = 'QUESTIONNAIRE';
    },

    computeTimeDiff(){
      var start = null;
      if(this.questionnaireExplorerIndex == 0){
        start = moment(this.exam.time.start);
      }else{
        start = moment(this.exam.questionnaire[this.questionnaireExplorerIndex-1].timeMark);
      }
      var end = moment(this.exam.questionnaire[this.questionnaireExplorerIndex].timeMark); // another date
      var duration = moment.duration(end.diff(start));
      var seconds = duration.asSeconds();
      return seconds;
      
    },

    computeTimes(){

      var timeLimitInMs = this.exam.time.start+(this.exam.time.limit*1000)

      var start = moment(this.exam.time.start); //todays date
      // var end = moment(this.exam.time.end); // another date
      var end = moment(this.exam.time.start+(this.exam.time.limit*1000)); 
      var duration = moment.duration(end.diff(start));
      var seconds = duration.asSeconds();

      this.exam.answers.forEach( (answer, i) => {
        let _data = {};
        _data.timeMark = answer.timeMark;
        // _data.timePercentage = ((answer.timeMark-this.exam.time.start)/(this.exam.time.end-this.exam.time.start))*100;
        _data.timePercentage = ((answer.timeMark-this.exam.time.start)/(this.exam.time.end-this.exam.time.start))*100;
        _data.isCorrect = (answer.answer.toString() == this.exam.questionnaire[i].answer.toString()) ? true : false;
        _data.isSkipped = answer.isSkipped;
        
        // time it took for the user to answer
        _data.userTookTime = (i == 0) ? (answer.timeMark - this.exam.time.start) : (answer.timeMark - this.exam.answers[i-1].timeMark);
        this.graphData.push(_data)
      });

      this.graphData.sort( (a, b) => {
        if (a.timePercentage > b.timePercentage) return 1
        if (b.timePercentage > a.timePercentage) return -1
        return 0; 
      })

      // this.timePerQuestion = this.exam.time.limit*1000/this.exam.answers.length;
      this.timePerQuestion = this.exam.time.limit/this.exam.questionnaire.length;
      console.log('this.timePerQuestion', this.timePerQuestion)
      
      // merge the user data with the questionnaire
      this.exam.answers.forEach( (e, i) => {
        this.exam.questionnaire[i].isSkipped = e.isSkipped;
        this.exam.questionnaire[i].timeMark = e.timeMark;
        this.exam.questionnaire[i].userAnswer = e.answer;
      })

      // sort via time mark
      this.exam.questionnaire.sort( (a, b) => {
        if (a.timeMark > b.timeMark) return 1
        if (b.timeMark > a.timeMark) return -1
        return 0; 
      })

      this.subject = this.getSubject(this.exam.subject);


    },
    updateSelected(s){
      this.selected = s;
      // console.log("this.selected has changed to: => ", this.selected)
    },
    getSubject(subject_id){
      return this.subjects.filter( e => { return (e.id == subject_id) })[0]
    },
    getSelectedSubtopicName(subtopic_id){
      if(this.subtopics == null) return
      return ( subtopic_id == "all-subjects") ? "All Subjects" : this.subtopics.filter( e => { return (e.id == subtopic_id) })[0].name
    },
    getSelectedSubjectName(subject_id){
      if(this.subjects == null) return
      return ( subject_id == "all-subjects") ? "All Subjects" : this.subjects.filter( e => { return (e.id == subject_id) })[0].name
    },
    computeRating(score, time_running, time_limit){
      /*
        Ratings are computed by following a 50:50 ratio between your recorded Score and Time Left Percentage.

        For Example:
        Username: Tony Stark
        Subject: Spelling
        Total No. of Items: 75 Items
        Time Limit: 15 minutes (900 seconds)

        Mock Exam Score: 69 out of 75 [ 92% ]
        Time Consumed: 7 minutes (420 seconds)
        Time Left: 8 minutes (480 seconds) [ 53.33% of the time limit ]			  

        Rating 	= [ 50% of Score Percentage ] + [ 50% of Time Left Percentage ]
                = [ 50% x 92% ] + [ 50% x 53.33% ]
                = [ 46% ] + [ 26.66% ]
                = 72.66%
      */

      let time_consumed = time_running;
      let time_left = time_limit - time_consumed;
      let time_left_percent = (time_left/time_limit)*100
      var rating = ( (score/2) + (time_left_percent/2) ).toFixed(2)
      return rating
    },

    // formatTime(time) {
    //   let momentedTime = this.moment("2015-01-01").startOf("day").seconds(time);
    //   return this.moment(momentedTime).format("HH:mm:ss");
    // },
  }
};
</script>
<style scoped>
select {
  /* Hide the default arrow */
  -webkit-appearance: none; /* For Safari/Chrome */
  -moz-appearance: none;    /* For Firefox */
  appearance: none;         /* Standard */
  background-image: none;   /* Remove default background arrow if any */
  padding-right: 20px; /* Adjust padding to make space for the custom arrow */
}

select::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #ff0000; /* Set the desired arrow color */
  pointer-events: none; /* Ensure the select element remains clickable */
}
</style>